<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Istoric SMS-uri"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label='Tip sms' >
                      <el-select class='full-width' v-model='Filters.TipSms' filterable size="small" >
                          <el-option label='Toate' value='-1'/>
                          <el-option label='Programare noua' value='Nou'/> 
                          <el-option label='Reminder - 2 ore' value='Reminder - 2 ore' />
                          <el-option label='Reminder - 9 ore' value='Reminder - 9 ore' />
                          <el-option label='Amanare' value='Amanare'/>
                          <el-option label='Anulare' value='Anulare'/>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Client">
                    <el-input v-model="Filters.NumeClient" class="full-width" size="small" />
                  </el-form-item>
                </el-col>                
                
                <el-col class="input-element">
                  <el-form-item label="Telefon">
                    <el-input v-model="Filters.Telefon" class="full-width" size="small" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label='Perioada'>
                    <br>
                    <el-date-picker
                        v-model="Filters.Data"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Data inceput"
                        end-placeholder="Data sfarsit"
                        :picker-options="datePickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd" size="small" >
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :md="24">
                  <el-button
                    type="primary"
                    native-type="submit"
                    @click="refresh_info()"
                  >
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>


      <el-table :data="Results">
      <el-table-column prop="Id" label="#" width="90px"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="Telefon" label="Telefon"></el-table-column>
      <el-table-column prop="TipSms" label="Tip SMS"></el-table-column>
      <el-table-column label="Data">
        <template slot-scope="scope">
          {{scope.row.Data | DataOraFaraSec}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Preview">
            <el-button
              type="info"
              icon="el-icon-view"
              circle

              @click="preview(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Retrimite">
            <el-button
              type="warning"
              icon="el-icon-position"
              circle
              @click="resend(scope.row.Id)"
            /> 
          </el-tooltip>
        </template>
      </el-table-column
    >

    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Preview-sms ref="dlg" />
  </base-page>
</template>

<script>
import moment from "moment";
import settings from "@/backend/LocalSettings";
import Preview_sms from './Preview_sms.vue';
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "istoric_programari",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    'Preview-sms': Preview_sms,
  },
  data() {
    return {
      datePickerOptions: {
        disabledDate(date) {
        return date > new Date();
        },
      },
      Results: [],
      base_url: "",
      Info: {
      },
      Filters: {
        NumeClient: "",
        TipSms: "-1",
        Data: [],
        Telefon: ""
      },
      OrderBy: {'Id': 'DESC'},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      // var response = await this.post("admin/istoric_programari/get_info");
      // this.Info.utilizatori = response.utilizatori;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/log_mesaj/index_sms", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("istoric_programari");
    },
    reset() {
      this.Filters = {
        NumeClient: "",
        TipSms: "-1",
        Data: [],
        Telefon: ""
      };
      this.refresh_info();
    },
    
    async resend(Id) {
      let args = {Id: Id};
      let respnse = await this.post('admin/log_mesaj/resend_sms', args);
      if (respnse.Raspuns = 'mesaj trimis') {
        this.$message({
          message: 'SMS retrimis!',
          type: 'success'
        });
      } else {
        this.$message({
          message: 'A intervenit o eroare in retrimiterea SMS-ului',
          type: 'danger'
        });
      }
    },

    preview(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right('Management')){
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 5%;
  width: 45%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
.tabel-data {
  word-break: keep-all;
  
}
</style>
